<dialog-gala (clickClose)="askHideModal()">
  <span gala-dialog-titre>{{lgTrad.AFFLAIT}}</span>
  <form [formGroup]="formData" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <select-gala [verylonglabel]="true" formControlName="ORGANISME" [options]="listeLaiteries"
          bindLabel="NOM" (selected)="chargerLaiterie($event)" container="#laiteries"
          [label]="lgTrad.LAITERIE" [disabled]="!droitsAccess.write || isEdition" />
        </div>
      </div>
      @if (isLaiterie == null || !isLaiterie) {
        <div class="row">
          <div class="col-md-12">
            <input-gala [verylonglabel]="true" type="number" [disabled]="!droitsAccess.write"
              formControlName="VOLUME" [label]="lgTrad.VANNUEL" customClass="input-text-number" />
            </div>
          </div>
        }
        @if (isLaiterie == null || !isLaiterie) {
          <div class="row">
            <div class="col-md-12">
              <input-gala [verylonglabel]="true" type="number" [disabled]="!droitsAccess.write"
                formControlName="VALORISATION" [label]="lgTrad.VALANNUELLE"
                customClass="input-text-number" />
              </div>
            </div>
          }
          @if (isLaiterie == null || isLaiterie) {
            <div class="row">
              <div class="col-md-12">
                <input-gala [verylonglabel]="true" type="number" [disabled]="!droitsAccess.write"
                  formControlName="REFANNUELLE" [label]="lgTrad.REFANNUELLE" customClass="input-text-number"
                  (keyup)="calculerDroit()" />
                </div>
              </div>
            }
            @if (isLaiterie == null || isLaiterie) {
              <div class="row">
                <div class="col-md-12">
                  <input-gala [verylonglabel]="true" type="number" [disabled]="!droitsAccess.write"
                    formControlName="ALLOCATION" [label]="lgTrad.ALLPROVISOIRE" customClass="input-text-number"
                    (keyup)="calculerDroit()" />
                  </div>
                </div>
              }
              @if (isLaiterie == null || isLaiterie) {
                <div class="row">
                  <div class="col-md-12">
                    <input-gala [verylonglabel]="true" type="number" [disabled]="true" formControlName="DROIT"
                      [label]="lgTrad.DROITAPROD" customClass="input-text-number" />
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col-md-12">
                    <date-gala [verylonglabel]="true" [label]="lgTrad.DEBUT" [placeholder]="lgTrad.BEGINNINGDATE"
                      formControlName="DDEBUT" [disabled]="!droitsAccess.write || isEdition" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <date-gala [verylonglabel]="true" [label]="lgTrad.FIN" [placeholder]="lgTrad.ENDDATE"
                        formControlName="DFIN" [disabled]="!droitsAccess.write" />
                      </div>
                    </div>

                  </form>
                  <div gala-dialog-actions>
                    @if (droitsAccess.write) {
                      <button mat-stroked-button color="primary" (click)="enregistrerLaiteries()"
                      >{{lgTrad.ENR}}</button>
                    }
                    <button mat-stroked-button color="accent" (click)="askHideModal()">{{lgTrad.RET}}</button>
                  </div>
                </dialog-gala>